import { getConfig } from '../../config';
import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { IAuditLogBody } from '../../model/api-modules';
import { store } from '../../store';

import { INGAME_CONSOLE_AUDIT_PROXY_PREFIX } from '../config';

// 审计中心上报
export const auditLogs = (data: IAuditLogBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const studioID = store.getState().studio.selectStudio?.studioID;
      const userID = store.getState().common.userInfo?.UserID || '';
      const url = `${INGAME_CONSOLE_AUDIT_PROXY_PREFIX}/v1/api/ingame/auditlogs/add?g6DomainURL=${
        getConfig().ingameConsoleURL?.default
      }&studioID=${studioID}`;
      const response = await api.commonRequest('POST', url, {
        ...data,
        operator: userID,
        operate_time: new Date().getTime(),
        source: 'portal',
      });
      await parsedResponse<any>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });

export const auditStudioLogs = (data: IAuditLogBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const studioID = store.getState().studio.selectStudio?.studioID;
      const userID = store.getState().common.userInfo?.UserID || '';
      const url = `${INGAME_CONSOLE_AUDIT_PROXY_PREFIX}/v2/api/ingame/auditlogs/add?g6DomainURL=${
        getConfig().ingameConsoleURL?.default
      }`;
      const response = await api.commonRequest('POST', url, {
        ...data,
        studio_id: studioID,
        operator: userID,
        operate_time: new Date().getTime(),
        source: 'portal',
      });
      await parsedResponse<any>(response, 'data');
      return true;
    } catch (error: any) {
      return false;
    }
  });
